dmx.mediumEditor.Button('imageRight', {
    contentDefault: '<b>Right</b>',
    contentFA: '<i class="fa fa-align-right"></i>',
    action: 'float-right',
    aria: 'Align image right',

    init: function() {
        MediumEditor.extensions.button.prototype.init.call(this);
    },

    isAlreadyApplied: function(node) {
        return node.classList.contains('medium-editor-image-upload-right');
    },

    handleClick: function(event) {
        var container = MediumEditor.util.getTopBlockContainer(MediumEditor.selection.getSelectionStart(this.document));
        if (container.classList.contains('medium-editor-image-upload')) {
            container.classList.remove('medium-editor-image-upload-left','medium-editor-image-upload-center','medium-editor-image-upload-full');
            container.classList.add('medium-editor-image-upload-right');
        }
        this.updateToolbar();
    },

    updateToolbar: function() {
        var toolbar = this.base.getExtensionByName('image-toolbar');
        if (toolbar) {
            toolbar.checkState();
        }
    }
});
